import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import CollapsibleTableRow from "../../../ui/collapsible-table-row";

const ruleOfThree = (val1, val2) => {
  return ((100 * val1) / val2).toFixed(2);
};

const numberToBrl = (number) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(number / 100);
};

const CnjTableRow = ({ row, totalValue }) => {
  const { name, total, history, enteData } = row;

  const header = () => (
    <>
      <TableCell align="center">{name}</TableCell>
      <TableCell align="center">{numberToBrl(total)}</TableCell>
    </>
  );

  return (
    <CollapsibleTableRow header={header()}>
      <Box margin={1}>
        <Table
          size="small"
          aria-label="purchases"
          style={{ marginBottom: "15px" }}
        >
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Municipal</TableCell>
              <TableCell>Estadual</TableCell>
              <TableCell>Federal</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {history.map((historyRow, i) => (
              <React.Fragment key={i}>
                <TableRow>
                  <TableCell>Valor total</TableCell>

                  <TableCell component="th" scope="row">
                    {numberToBrl(historyRow.municipal)}
                  </TableCell>

                  <TableCell component="th" scope="row">
                    {numberToBrl(historyRow.estadual)}
                  </TableCell>

                  <TableCell>{numberToBrl(historyRow.federal)}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>% em relação ao total da seleção</TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.municipal, total)}
                  </TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.estadual, total)}
                  </TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.federal, total)}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>% em relação ao total do CNJ</TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.municipal, totalValue)}
                  </TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.estadual, totalValue)}
                  </TableCell>

                  <TableCell>
                    {ruleOfThree(historyRow.federal, total)}
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </Box>

      {!!enteData?.Municipal && (
        <Table size="small">
          <TableBody>
            <CollapsibleTableRow header={<TableCell>Municípios</TableCell>}>
              <Box margin={1}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell>Valor Total</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {Object.keys(enteData.Municipal).map((city) => {
                      if (city === "valores") {
                        return;
                      }

                      const cityData = enteData.Municipal[city];

                      return (
                        <TableRow key={city}>
                          <TableCell>{city.replace(/-\D{2}$/, "")}</TableCell>
                          <TableCell>{numberToBrl(cityData.valores)}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </CollapsibleTableRow>
          </TableBody>
        </Table>
      )}
    </CollapsibleTableRow>
  );
};

export default CnjTableRow;

CnjTableRow.propTypes = {
  row: PropTypes.shape({
    total: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        municipal: PropTypes.number.isRequired,
        estadual: PropTypes.number.isRequired,
        federal: PropTypes.number.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};
